import * as React from "react";
import { Suspense } from "react";
import MainRoutes from "./MainRoutes";
import Loader from "../ui-component/extended/Loader/Loader";
const Routes = () => {
  return (
      <Suspense fallback={<Loader />}>
            <MainRoutes />    
      </Suspense>  
  );
};
export default Routes;